import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-support',
  templateUrl: './icon-support.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSupportComponent {}
